import { render, staticRenderFns } from "./OutStockBase.vue?vue&type=template&id=c96d3c7c&"
import script from "./OutStockBase.vue?vue&type=script&lang=js&"
export * from "./OutStockBase.vue?vue&type=script&lang=js&"
import style0 from "./OutStockBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports